<template>
  <div
    class="form"
    :class="{ 'form--dark': isDarkMode }"
    :key="editorFormKey"
    v-if="value && value.module"
  >
    <div
      v-if="
        value.module == 'ifstep' || value.module == 'loop' || mode !== 'input'
      "
    >
      <div
        title="If not empty, only run the step if the go template condition is true"
        class="form small-extra-bold d-flex"
        :class="{ 'form--dark': isDarkMode }"
      >
        Condition <v-spacer />
        <div
          class="d-flex p2-extra-bold cyan--text align-center pointer"
          :data-template="value.if"
          @click="showConditionTester()"
        >
          <div>CONDITION TESTER</div>
          <apio-icon
            class="ml-1"
            name="ui-new-window"
            lightModeColour="cyan"
            darkModeColour="cyan"
          />
        </div>
      </div>
      <Help article="step-condition" />
      <Editor
        height="1"
        id="if"
        class="flex-grow-1"
        type="text"
        :placeholder="'eq .Payload.a'"
        :showlang="true"
        v-model="value.if"
      />
    </div>

    <div
      class="d-flex flex-column mb-6"
      v-if="value && value.module.endsWith('_poll')"
      title="Polling frequency, delay in seconds"
    >
      <Help article="input-frequency" />
      <div
        class="form small-extra-bold"
        :class="{ 'form--dark': isDarkMode }"
        for="frequency"
      >
        Frequency<v-spacer />
      </div>
      <v-text-field
        hide-details="auto"
        dense
        outlined
        height="1"
        id="frequency"
        placeholder="10"
        type="number"
        v-model.number="value['frequency']"
        :env="env"
      />
    </div>

    <div v-if="settings !== undefined && settings.form !== undefined">
      <div v-for="(item, i) in settings.form" :key="i">
        <div
          v-if="conditionCheck(value[value.module], item)"
          label-cols="2"
          :label="item.label"
          :title="item.tooltip"
        >
          <EditorLine
            :label="item.label"
            :item="item"
            :value="value[value.module]"
            :dataSource="value.data"
            :conf="value.conf"
            :env="env"
            :steps="steps"
          />
        </div>
      </div>
    </div>
    <div
      v-if="
        addons[mode + '_' + value.module] != undefined &&
        addons[mode + '_' + value.module].includes('parser')
      "
    >
      <div
        class="form p1-extra-bold mr-6"
        :class="{ 'form--dark': isDarkMode }"
      >
        Parser
      </div>
      <div v-for="(item, i) in conf['parser'].form" :key="i">
        <div
          v-if="conditionCheck(value.parser, item)"
          label-cols="2"
          :label="item.label"
          :title="item.tooltip"
        >
          <EditorLine
            :label="item.label"
            :item="item"
            :value="value.parser"
            :conf="value.conf"
            :env="env"
            :steps="steps"
          />
        </div>
      </div>
    </div>
    <div
      v-if="
        addons[mode + '_' + value.module] != undefined &&
        addons[mode + '_' + value.module].includes('sync_in')
      "
    >
      <div
        class="form p1-extra-bold mb-2"
        :class="{ 'form--dark': isDarkMode }"
      >
        Sync In
      </div>

      <div v-for="(item, i) in conf['sync_in'].form" :key="i">
        <div
          v-if="conditionCheck(value.sync_in, item, 'sync_in')"
          label-cols="2"
          :label="item.label"
          :title="item.tooltip"
        >
          <EditorLine
            :label="item.label"
            :item="item"
            :value="value.sync_in"
            :conf="value.conf"
            :env="env"
            :steps="steps"
          />
        </div>
      </div>
    </div>

    <div
      v-if="value && value.module === 'senddata'"
      class="d-flex flex-row align-center mb-6"
    >
      <div
        class="form p2-extra-bold mr-6"
        :class="{ 'form--dark': isDarkMode }"
      >
        Paths {{ pos }}
      </div>
      <v-tooltip bottom :disabled="!getLabelNames">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" @click="launchDataMapperDialog">
            <apio-checkbox
              readonly
              v-if="getLabelNames.length"
              :value="getLabelNames"
              :checked="getLabelNames.length ? true : false"
            ></apio-checkbox>
            <apio-checkbox readonly v-else></apio-checkbox>Data Mapper
          </v-btn>
        </template>
        <span v-if="getLabelNames" v-html="getLabelNames"></span>
      </v-tooltip>
    </div>

    <v-dialog
      v-model="dataMapperDialog"
      class="datamapper"
      permanent
      fullscreen
    >
      <v-card flat>
        <v-card-text>
          <data-mapper :viewSource="d" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-expansion-panels active-class="" class="mb-2" flat>
      <v-expansion-panel @click="onExpansionPanelClick" color="white">
        <v-expansion-panel-header class="form__view-source--header">
          <div class="p1-extra-bold">{{ headerText }}</div>
          <template v-slot:actions>
            <apio-icon
              :lightModeColour="headerIconColour"
              :darkModeColour="headerIconColour"
              :name="headerIconName"
            >
              $expand
            </apio-icon>
          </template>
        </v-expansion-panel-header>
        <monaco-editor
          id="view-source"
          v-if="settings !== undefined && showSource"
          :options="monacoOptions"
          v-model="d"
          :textarea="true"
          class="view-source"
        />
      </v-expansion-panel>
    </v-expansion-panels>

    <v-dialog title v-model="conditionTesterStatus" fullscreen>
      <v-card flat>
        <v-toolbar flat color="apioshade3" class="white--text h2 mb-1">
          <div class="white--text run-step__title">Condition Tester</div>
          <v-spacer></v-spacer>
          <apio-button
            button-type="get-started"
            button-size="small"
            @click="conditionTesterStatus = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
        </v-toolbar>
        <ConditionTester
          class="pa-6"
          :input="conditionTesterInput"
          v-model="conditionTesterTemplate"
          @condition-input="inputConditionTester"
        />
      </v-card>
    </v-dialog>

     <v-dialog title v-model="templateTesterStatus" fullscreen>
      <v-card flat>
        <v-toolbar flat color="apioshade3" class="white--text h2 mb-1">
          <div class="white--text run-step__title">Template Tester</div>
          <v-spacer></v-spacer>
          <apio-button
            button-type="get-started"
            button-size="small"
            @click="templateTesterStatus = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
        </v-toolbar>
        <Tester
          class="pa-6"
          :input="templateTesterInput"
          :handle="templateTesterHandle"
          v-model="templateTesterTemplate"
          :env="env"
          @template-input="inputTemplateTester"
        />
      </v-card>
    </v-dialog>

    <v-dialog title v-model="javascriptTesterStatus" fullscreen>
      <v-card flat>
        <v-toolbar flat color="apioshade3" class="white--text h2 mb-1">
          <div class="white--text run-step__title">Javascript Tester</div>
          <v-spacer></v-spacer>
          <apio-button
            button-type="get-started"
            button-size="small"
            @click="javascriptTesterStatus = false"
            >Close
            <apio-icon
              class="ml-2"
              size="16"
              name="cross"
              lightModeColour="white"
              darkModeColour="white"
          /></apio-button>
        </v-toolbar>
        <JSTester
          class="pa-6"
          :input="javascriptTesterInput"
          v-model="javascriptTesterTemplate"
          @javascript-input="inputJavascriptTester"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MonacoEditor from "vue-monaco";
var uuid = require("uuid");

export default {
  name: "Form",
  components: {
    Editor: () => import("@/components/Editor.vue"),
    Tester: () => import("@/components/Editor/Tester.vue"),
    JSTester: () => import("@/components/Editor/JSTester.vue"),
    ConditionTester: () => import("@/components/Editor/ConditionTester.vue"),
    EditorLine: () => import("@/components/Editor/FormLine.vue"),
    DataMapper: () => import("@/components/DataMapper/DataMapper.vue"),
    Help: () => import("@/components/Help/Help.vue"),
    MonacoEditor,
  },
  props: {
    value: {},
    settings: {},
    conf: {},
    env: {},
    mode: {},
    steps: {
      type: Array,
      required: false,
    },
  },
  data: () => ({
    headerText: "View source",
    headerIconName: "chevron-down",
    headerIconColour: "cyan",
    dataMapperDialog: false,
    conditionTesterStatus: false,
    templateTesterStatus: false,
    javascriptTesterStatus: false,
    javascriptTesterTemplate: "",
    templateTesterTemplate: "",
    conditionTesterTemplate: "",
    templateTesterHandle: "",
    advanced: false,
    viewSource: false,
    options: {},
    addons: {
      input_http_listen: ["parser", "sync_in"],
      input_file: ["parser", "sync_in"],
      input_http_poll: ["parser"],
      input_sftp_poll: ["parser", "sync_in"],
      step_http: ["parser"],
      step_command: ["parser"],
      input_ftps_poll: ["parser", "sync_in"],
    },
    templateTesterInput: "",
    javascriptTesterInput: "",
    conditionTesterInput: "",
    editorFormKey: uuid.v4(),
    pos: "",
    monacoOptions: {
      theme: "vs" || this?.vsTheme,
      automaticLayout: true,
      autoIndent: true,
      contextmenu: false,
      formatOnType: true,
      minimap: {
        enabled: false,
      },
      lineNumbers: false,
    },
    showSource: false,
  }),
  mounted() {
    this.$root.$on("closeDataMapper", () => {
      this.dataMapperDialog = false;
    });

    this.$store.subscribe((mutation) => {
      if (
        this.value &&
        this.value.module === "senddata" &&
        (mutation.type === "ADD_TAG" ||
          mutation.type === "REMOVE_DATA_MAPPER_LABEL") &&
        mutation.payload &&
        this.datamapper.sendData.paths
      ) {
        this.value["senddata"].paths = this.datamapper.sendData.paths;
      }
    });
    this.$root.$on("show-template-tester", this.showTemplateTester);
    this.$root.$on("show-javascript-tester", this.showJavascriptTester);
    this.$root.$on("show-condition-tester", this.showConditionTester)
    this.$root.$on("update-editor-form", () => {
      this.editorFormKey = this.uuid();
    }); //trigger dom update
    if (
      this.addons[this.mode + "_" + this.value.module] != undefined &&
      this.addons[this.mode + "_" + this.value.module].includes("sync_in")
    ) {
      if (this.value["sync_in"] == undefined) {
        this.value["sync_in"] = {};
      }
    }
    if (
      this.addons[this.mode + "_" + this.value.module] != undefined &&
      this.addons[this.mode + "_" + this.value.module].includes("parser")
    ) {
      if (this.value["parser"] == undefined) {
        this.value["parser"] = {};
      }
    }
  },
  computed: {
    d: {
      get: function () {
        if (typeof this.value == "object") {
          return JSON.stringify(this.value, undefined, 2);
        }
        return this.value;
      },
      set: function (val) {
        this.$emit("input", JSON.parse(val));
      },
    },
    ...mapState({
      datamapper: (state) => state.datamapper,
    }),
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    vsTheme() {
      return this.isDarkMode ? "vs-dark" : "vs";
    },
    getLabelNames() {
      if (this.value && this.value.senddata && this.value.senddata.paths) {
        const paths = this.value.senddata.paths;
        const x = paths.map((path) => {
          return `${path.label}`;
        });
        return x.join("<br>");
      }
      return "";
    },
  },
  methods: {
    onExpansionPanelClick(event) {
      this.showSource = !this.showSource;
      if (
        event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        this.headerText = "View source";
        this.headerIconName = "chevron-down";
        this.headerIconColour = "cyan";
      } else {
        this.headerText = "Hide source";
        this.headerIconName = "chevron-up";
        this.headerIconColour = "purple";
      }
    },
    uuid() {
      return uuid.v4();
    },
    cursorMove(p) {
      this.pos = p.pos;
    },
    launchDataMapperDialog() {
      // 1. Open dialog with viewSource.data if it is available

      if (JSON.stringify(this.value["senddata"]) == "{}") {
        this.value["senddata"].paths = [];
      }
      this.dataMapperDialog = true;
      if (this.value.module === "senddata") {
        if (this.dataMapperLabels === undefined) {
          this.$store.dispatch(
            "updateDataMapperLabels",
            this.value["senddata"].paths
          );
        }
      }
    },
    inputTemplateTester({val, handle}) {
      this.value[this.value.module][handle] = val;
    },
    inputJavascriptTester(val) {
      this.value[this.value.module].javascript = val;
    },
    inputConditionTester(conditionValue) {
      this.value.if = conditionValue;
    },
    showTemplateTester({ value, handle }) {
      this.templateTesterHandle = handle;
      this.templateTesterTemplate = value;
      this.templateTesterStatus = true;
    },
    showConditionTester() {
      this.conditionTesterTemplate = this.value.if;
      this.conditionTesterStatus = true;
    },
    showJavascriptTester({ value }) {
      this.javascriptTesterTemplate = value;
      this.javascriptTesterStatus = true;
    },
    getopts(s) {
      return s.replace("[", "").replace("]", "").split(",");
    },
    conditionCheck(value, item) {
      if (value == undefined) return true;
      if (item == undefined) return true;
      if (item.if == "") return true;
      let field = item.if;
      let val = "";
      if (field.includes(":")) {
        let parts = field.split(/:(.+)/);
        if (parts.length == 3) {
          field = parts[0];
          val = parts[1];

          if (val === "true") {
            return value[field];
          }
          if (val === "false") {
            return !value[field];
          }
        }
      }
      if (val.includes(",")) {
        let parts = val.split(",");
        if (parts.includes(value[field])) {
          return true;
        }
        return false;
      }
      return value[field] == val;
    },
  },
};
</script>
<style lang="scss">
.form {
  color: var(--apio-shade-5);

  &--dark {
    color: var(--apio-shade-4);
  }
}

.v-expansion-panel-content__wrap {
  border-bottom-width: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border: 1px solid var(--apio-purple) !important;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top: 0 !important;
  height: 100%;
  // padding: 0;

  & > .outer {
    border: none !important;
  }
}
.v-expansion-panel-header {
  border: 1px solid var(--apio-cyan);
  border-radius: 4px;
  color: var(--apio-cyan);
  font-size: var(--font-paragraph-2-size);
  font-weight: var(--font-extra-bold);

  &--active {
    color: var(--apio-purple);
    border: 1px solid var(--apio-purple);
    border-bottom-color: var(--apio-shade-5);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>
<style scoped lang="scss">
.pointer {
  cursor: pointer;
}

::v-deep .form {
  color: var(--apio-shade-2);

  &--dark {
    color: var(--apio-shade-4);
  }
}

input,
textarea,
input:focus,
textarea:focus {
  border: none;
  border-radius: 0;
}

::v-deep .v-dialog--fullscreen {
  overflow-y: hidden;
}

::placeholder {
  color: grey;
}

:-ms-input-placeholder {
  color: grey;
}

::-ms-input-placeholder {
  color: grey;
}
</style>
<style lang="scss" scoped>
::v-deep .view-source {
  border: 1px solid var(--apio-purple);
  height: 200px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>
